import { all } from 'redux-saga/effects';
import { widgetFrameworkSagas } from '@erecruit/modules';

import { default as requestPositionSagas } from '../../components/RequestPosition/state/sagas';
import { default as matchSearchSagas } from '../../components/MatchSearch/state/sagas';
import { saga as notifications } from '../../components/Notifications';
import { saga as problemReportSagas } from '../../components/ProblemReport';
import { default as positionSearchSagas } from '../../components/PositionSearch/state/sagas';
import { default as shiftSearchSagas } from '../../components/ShiftSearch/state/sagas';
import { default as shiftRecordSagas } from '../../components/ShiftRecord/state/sagas';
import { sagas as addNewShiftSagas } from '../../components/AddNewShiftWizard';
import { default as positionRecordSagas } from '../../components/PositionRecord/state/sagas';
import { default as matchRecordSagas } from '../../components/MatchRecord/state/sagas';
import { saga as broadcastMessagesSagas } from '../../components/BroadcastMessages';

export default function* appSaga() {
  yield all([
    requestPositionSagas(),
    ...shiftSearchSagas,
    ...shiftRecordSagas,
    ...widgetFrameworkSagas,
    ...matchSearchSagas,
    ...notifications,
    ...positionSearchSagas,
    ...positionRecordSagas,
    ...matchRecordSagas,
    ...addNewShiftSagas,
    ...broadcastMessagesSagas,
    ...problemReportSagas,
  ]);
}
